module.exports = __webpack_public_path__ + "static/img/3.0cd897d8.png";